import { Button, Card, Col, Row, Select, DatePicker, Spin } from "antd";
import { GenderDistributionView } from "../components/Demographic/GanderView";
import { DemographicAgeGroup } from "../components/Demographic/DemographicAgeGroup";
import { NationalitiesDemoGraphicView } from "../components/Demographic/Nationalitiesdemographic";
import { ResidenceDemoView } from "../components/Demographic/ResidenceDemographic";
import { useGetDashboardDemographic } from "../use-cases/get-demographicDashBoard";
import { useState } from "react";
import dayjs from "dayjs";
import cash from 'assets/Dashboard/Money.svg';
import { demographic } from "components/side-bar/utils";
import { FilterOutlined } from "@ant-design/icons";
import { useGetDashboardCardCommon } from "../use-cases/get-commonDropDown";

const { RangePicker } = DatePicker;

export const DemographicregistrationView = () => {
    const [selectedYear, setSelectedYear] = useState<number | null>(null);
    const [selectedEvent, setSelectedEvent] = useState<string | undefined>();
    const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
    const [dateRange, setDateRange] = useState<[dayjs.Dayjs, dayjs.Dayjs] | null>(null);

    const commonParams = {
        FromDate: dateRange?.[0]?.format("YYYY-MM-DD") || "",
        ToDate: dateRange?.[1]?.format("YYYY-MM-DD") || "",
        Year: selectedYear || "",
        EventId: selectedEvent || "",
        CategoryId: selectedCategories.join(",") || "",
    };

    const { data: GenderData, isFetching: Genderfetch } = useGetDashboardDemographic({ ...commonParams, flag: "Gender" });
    const { data: AgeData } = useGetDashboardDemographic({ ...commonParams, flag: "Age" });
    const { data: NationalitiesData } = useGetDashboardDemographic({ ...commonParams, flag: "Nationality" });
    const { data: ResidenceData } = useGetDashboardDemographic({ ...commonParams, flag: "Country" });
    const { data: carddata } = useGetDashboardDemographic({ ...commonParams });
    const { data: eventsData } = useGetDashboardCardCommon({ Flag: 'events',year:selectedYear });

    const { data: categoriesData, isFetching: loading } = useGetDashboardCardCommon(
        selectedEvent
            ? { Flag: 'categorylist', MultipleIds: selectedEvent }
            : { enabled: false }
    );
    const years = Array.from({ length: 10 }, (_, i) => ({
        label: (dayjs().year() - i).toString(),
        value: dayjs().year() - i,
    }));

    const handleApplyFilters = () => {
        // if (selectedYear == dateRange) {
        //     setDateRange(null)
        // }
        // Trigger re-fetch if needed
    };

    const handleReset = () => {
        setSelectedYear(null);
        setSelectedEvent(undefined);
        setSelectedCategories([]);
        setDateRange([dayjs(), dayjs()]);
    };

    return (
        <>
            <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                <Col span={24} style={{ padding: '0' }}>
                    <Card className="filtr_card filt_repn">
                        {/* Date Range */}
                        <RangePicker
                            style={{ marginRight: 16 }}
                            value={dateRange}
                            onChange={(dates: any) => {
                                setDateRange(dates);
                                if (dates) {
                                    setSelectedYear(null); // ✅ clear year if date range selected
                                }
                            }}
                        />

                        {/* Year Filter */}
                        <Select
                            showSearch
                            options={years}
                            value={selectedYear}
                            onChange={(value) => {
                                setSelectedYear(value);
                                if (value) {
                                    setDateRange(null); // ✅ clear date range if year selected
                                }
                            }}
                            style={{ width: 120, marginRight: 16 }}
                            placeholder="Select Year"
                            allowClear
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                            }
                        />
                        {/* Event Filter */}
                        <Select
                            showSearch
                            placeholder="Filter by Event"
                            value={selectedEvent}
                            onChange={(value) => {
                                setSelectedEvent(value);
                                setSelectedCategories([]);
                            }}
                            style={{ width: 150, marginRight: 16 }}
                            allowClear
                            optionFilterProp="label"
                            filterOption={(input, option) => {
                                const label = option?.label;

                                return typeof label === "string" && label.toLowerCase().includes(input.toLowerCase());
                            }}
                            dropdownRender={(menu) => (
                                <div>
                                    <div
                                        style={{
                                            padding: 8,
                                            fontWeight: 500,
                                            borderBottom: '1px solid #f0f0f0',
                                        }}
                                    >
                                        <FilterOutlined style={{ marginRight: 6 }} />
                                        Select Event
                                    </div>
                                    {menu}
                                </div>
                            )}
                            options={
                                eventsData?.dropDownList?.map((e: any) => ({
                                    label: e.Name,
                                    value: e.Id,
                                })) || []
                            }
                        />

                        {/* Category Filter (MULTIPLE) */}
                        <Select
                            mode="multiple"
                            showSearch
                            placeholder="Filter by Category"
                            value={selectedCategories}
                            onChange={(values) => setSelectedCategories(values)}
                            style={{ width: 180 }}
                            allowClear
                            optionFilterProp="label"
                            filterOption={(input, option) => {
                                const label = option?.label;

                                return typeof label === "string" && label.toLowerCase().includes(input.toLowerCase());
                            }}
                            dropdownRender={(menu) => (
                                <div>
                                    <div
                                        style={{
                                            padding: 8,
                                            fontWeight: 500,
                                            borderBottom: '1px solid #f0f0f0',
                                        }}
                                    >
                                        <FilterOutlined style={{ marginRight: 6 }} />
                                        Select Category
                                    </div>
                                    {menu}
                                </div>
                            )}
                            options={
                                categoriesData?.dropDownList?.map((c: any) => ({
                                    label: c.Name,
                                    value: c.Id,
                                })) || []
                            }
                            disabled={!selectedEvent}
                        />

                        {/* Buttons */}
                        <Button
                            type="primary"
                            style={{ marginLeft: "16px", marginRight: "10px" }}
                            onClick={handleApplyFilters}
                        >
                            Filter
                        </Button>
                        <Button onClick={handleReset}>Cancel</Button>
                    </Card>
                </Col>
            </Row>

            <Row gutter={[16, 16]} className="respn_row">
                {(Array.isArray(carddata) ? carddata : []).map((item: any, index: number) => (
                    <Col span={6} key={index}>
                        <div className="sales_regis">
                            <Spin spinning={loading}>
                                <Card style={{ backgroundColor: demographic[item.Name] || "#fff" }}>
                                    
                                      
                                        <p style={{ fontSize: 16, color: "#fff" }}>{item.Name}</p>
                                    
                                    <div className="card_img_t">
                                    <h2 style={{ fontSize: 16, color: "#fff" }}>{item.Value}</h2>
                                      <img src={cash} alt="" width={40} height={40} />
                                      </div>
                                </Card>
                            </Spin>
                        </div>
                    </Col>
                ))}
            </Row>


            <Row gutter={[16, 16]} className="row_gap">
                <Col span={12} className="respn_col">
                    <Spin spinning={Genderfetch}><GenderDistributionView data={GenderData} /></Spin>
                </Col>
                <Col span={12} className="respn_col">
                    <Spin spinning={Genderfetch}><DemographicAgeGroup data={AgeData} /></Spin>
                </Col>
                <Col span={12} className="respn_col">
                    <Spin spinning={Genderfetch}><NationalitiesDemoGraphicView data={NationalitiesData} /></Spin>
                </Col>
                <Col span={12} className="respn_col">
                    <Spin spinning={Genderfetch}><ResidenceDemoView data={ResidenceData} /></Spin>
                </Col>
            </Row>
        </>
    );
};
